import React from 'react'
import { AppRetailerBlock } from "@components"


export default function sitesColumn() {
	return {
		name: 'site',
		label: 'Website',
		options: {
			customBodyRowRenderLite: (value, { market, ico }) => {
				return <AppRetailerBlock retailer={value} country={market} icon={ico}/>
			}
		}
	}
}